import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';

const UpArrowButton = ({ enabled, size, onClick, children }) => {
  return (
    <div
    style={{
      cursor: enabled ? 'pointer' : 'not-allowed',
      padding: '10px 20px',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',      
      marginTop: '-10px',
      marginBottom: '-15px'
    }}
    onClick={enabled ? onClick : null}
    disabled={!enabled}
    >
      <FontAwesomeIcon icon={faCaretUp} size={size} style={{ color: enabled ? 'green' : 'gray' }}/>
      {children}
    </div>
  );
};

export default UpArrowButton;
